// extracted by mini-css-extract-plugin
export default {"card":"Discord_card__MBsKC","card__header":"Discord_card__header__bG5GN","card__title":"Discord_card__title__29f+p","card__image":"Discord_card__image__j2kTM"};